$(document).on("click",".field_set-optionList",function() {
  if($(this).hasClass('it_on')){
    $(this).removeClass('it_on');
  }else{
    $(this).addClass('it_on');
  }
});





$(document).on("click", ".dropdown_list li", function () {
  var value = $(this).data("title"); // e.g. "B1"
  var fullText = $(this).text().trim(); // e.g. "B1: 70x100 cm"

  // Highlight the selected list item
  $(this).siblings("li").removeClass("text_select");
  $(this).addClass("text_select");

  // Find the correct wrapper scope
  var $fieldSet = $(this).closest(".field_set-optionList");
  var $variantWrapper = $(this).closest(".variant-wrapper");

  // Highlight the matching .variant_select-product
  $fieldSet.find(".variant_select-product").removeClass("active_seclet");
  $fieldSet
    .find('.variant_select-product[data-title="' + value + '"]')
    .addClass("active_seclet");

  // Find the matching variant input (handle cases like "B1" vs "B1: 70x100 cm")
  var $radioInput = $variantWrapper
    .find(".variant-input-wrap .variant-input")
    .filter(function () {
      var dataValue = $(this).data("value");
      return dataValue === value || dataValue.startsWith(value + ":");
    })
    .find('input[type="radio"]');

  if ($radioInput.length) {
    // Set radio checked and trigger Shopify change event
    $radioInput.prop("checked", true).trigger("change");

    // Also trigger click on label for styling consistency
    $radioInput.siblings("label").trigger("click");
  }

  // ✅ Update the visible selected option text (like “A0” → “B1: 70x100 cm”)
  var optionName = $variantWrapper.find(".variant-input-wrap").attr("data-handle");
  if (optionName) {
    $("#selected-option-value-" + optionName).text(fullText);
  }

  // Wait for variant updates to complete
  setTimeout(function () {
    var selectedOptions = [];

    $(".variant-input-wrap").each(function () {
      var checked = $(this).find('input[type="radio"]:checked');
      if (checked.length) {
        selectedOptions.push(checked.val().trim());
      }
    });

    var productJsonEl = document.querySelector(
      '[type="application/json"][data-product-json]'
    );
    if (!productJsonEl) return;

    var productData = JSON.parse(productJsonEl.textContent);

    var matchedVariant = productData.variants.find(function (v) {
      return v.options.every(function (opt, i) {
        return opt.trim() === selectedOptions[i];
      });
    });

    if (matchedVariant) {
      $('input[name="id"]').val(matchedVariant.id);
    }
  
  }, 30);



  
});









$(document).ready(function () {
  
  // [data-fancybox="preview"]
  // $('.product-image-main a.fancybox').fancybox({
  //   // Enable zoom feature
  //         buttons: [
  //         "slideShow",
  //         "thumbs",
  //         "zoom",
  //         "close"
  //       ],
  //       loop: false,
  //       protect: false,
  //       width: 750,
  //       height: 750,
  //       // Callback function triggered before zoom
  // });

        function initPopup() {
          var screenWidth = window.innerWidth;
          var $productListInner = $('.product-image-main a.fancybox');
          if (screenWidth <= 740) {
             $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                width: 750,
        height: 750,
                  // Callback function triggered before zoom
            });
          }else{
            $productListInner.fancybox({
              // Enable zoom feature
                    buttons: [
                    "slideShow",
                    "thumbs",
                    "zoom",
                    "close"
                  ],
                  loop: true,
                  protect: false,
                  // Callback function triggered before zoom
            });
          }
        }

        initPopup();
        $(window).on('resize', initPopup);
})

$( document ).ready(function() {
  if(window.location.href.includes('/products/')){
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
    $('[name="Border Options"]~.custom-dropdown .dropdown_list [data-title="No Border"]').click();
  }
});


$(document).ready(function() {
    function checkSelectedFrame() {
                var selectedSlide = $('.product-main-slide.is-selected');
                if (selectedSlide.attr('data-frame') === 'frame') {
                   $('.grid--product-images--partial').attr('data-enable-frame', true);
                } else {
                    $('.grid--product-images--partial').attr('data-enable-frame', false);
                }
            }
  var targetNode = document.querySelector('.product-slideshow .flickity-slider'); // Corrected this line
  
  if (targetNode) { 
    var observer = new MutationObserver(function(mutationsList, observer) {
      
      for (var mutation of mutationsList) {
        if (mutation.attributeName === 'class') {
         checkSelectedFrame();
          break;
        }
      }
    });

    var config = { attributes: true, childList: true, subtree: true };
    observer.observe(targetNode, config);
  } 
  
    var $drawerInner = $('.drawer__inner');
    var $shipInsurance = $('.drawer__footer');
    var isShown = true;
  
    $drawerInner.on('scroll', function () {
        var scrollTop = $drawerInner.scrollTop();
        var scrollHeight = $drawerInner.prop('scrollHeight');
        var innerHeight = $drawerInner.innerHeight();
        var distanceFromBottom = scrollHeight - (scrollTop + innerHeight);

        if (scrollTop > 10 && distanceFromBottom > 100) {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideUp()
            // $('.drawer__footer').addClass('drawer__footer--fixed');
          if (isShown) {
            isShown = false;
          }
        } else {
          $('.drawer__footer .ship-insurance, .drawer__footer .additional-checkout-buttons').slideDown()
            // $('.drawer__footer').removeClass('drawer__footer--fixed');
          if (!isShown) {
             isShown = true;
          }
        }
    });
});


// frames and canvas logic starts here

document.addEventListener("DOMContentLoaded", function () {
    const radioCanvas = document.getElementById("radio-canvas");
    const radioPrint = document.getElementById("radio-print");
    const selectedOptionFrame = document.getElementById("selected-option-value-frame");

    const frameVariants = document.querySelectorAll(".amr-Frame .variant-input[data-value]:not([data-value*='Canvas'])");
    const canvasVariants = document.querySelectorAll(".amr-Frame .variant-input-wrap  [data-value*='Canvas']");
    const unframedVariant = document.querySelector(".variant-input[data-value='Unframed']");
    const line_item_parent_effect = document.querySelector(".line-item-parent-effect");
    let noBorderRadio = document.querySelector(".fk-bcpo-radios input[type='radio'][value='No Border']");
    let border_option = document.querySelector(".fk-line-item-parent-effect");
    const canvasLabelText = "Stretched Canvas - No Outside Frame"; // Fixed text for Canvas mode
    let isCanvasActive = false; // Flag to track whether Canvas mode is active

    function selectVariant(variant) {
        if (variant) {
            const input = variant.querySelector("input");
            input.checked = true;
            input.dispatchEvent(new Event("change", { bubbles: true })); // Trigger change event
            
            // If Canvas is active and Unframed is selected, show fixed text
            // if (isCanvasActive && variant.dataset.value === "Unframed") {
            //     updateSelectedOption(canvasLabelText);
            // } else if (!isCanvasActive) {
            //     updateSelectedOption(variant.dataset.value);
            // }
        }
    }

    // function showFrames() {
    //     isCanvasActive = false; // Disable Canvas mode
    //     frameVariants.forEach(variant => (variant.style.display = "inline-block"));
    //     canvasVariants.forEach(variant => (variant.style.display = "none"));
    //     unframedVariant.style.display = "inline-block"; // Ensure Unframed is shown
    //     selectVariant(unframedVariant);
    //     if(border_option){
    //       border_option.style.display = "flex";
    //     }
    //    $('.hidden_canvas_frame').val('');
    // }
function showFrames() {
  isCanvasActive = false;
  frameVariants.forEach(variant => (variant.style.display = "inline-block"));
  canvasVariants.forEach(variant => (variant.style.display = "none"));
  if (unframedVariant) {
    unframedVariant.style.display = "inline-block";
  }
  if (border_option) {
    border_option.style.display = "flex";
  }
  $('.hidden_canvas_frame').val('');
  const firstVisibleFrame = $('.amr-Frame .variant-input.var-input')
    .filter(function () {
      return $(this).css('display') === 'inline-block';
    })
    .first()
    .find('input[type="radio"]');
  if (firstVisibleFrame.length) {
    firstVisibleFrame.click();
  }
}

    // function showCanvas() {
    //     isCanvasActive = true; 
    //     frameVariants.forEach(variant => (variant.style.display = "none"));
    //     canvasVariants.forEach(variant => (variant.style.display = "inline-block"));
    //     selectVariant(unframedVariant); 
    //     if (noBorderRadio && !noBorderRadio.checked) {
    //       noBorderRadio.checked = true;
    //       noBorderRadio.dispatchEvent(new Event("change", { bubbles: true }));
    //       noBorderRadio.click();
    //     }
    //     if(border_option){
    //        border_option.style.display = "none";
    //     }
    //     const firstCanvasVariant = $('.amr-Frame .variant-input.var-input').last();
    //     if (firstCanvasVariant.length) {
    //       firstCanvasVariant.find('input[type="radio"]').click();
    //     }
    // }



  function showCanvas() {
      isCanvasActive = true;
      frameVariants.forEach(variant => (variant.style.display = "none"));
      canvasVariants.forEach(variant => (variant.style.display = "inline-block"));
      selectVariant(unframedVariant);

      if (noBorderRadio && !noBorderRadio.checked) {
        noBorderRadio.checked = true;
        noBorderRadio.dispatchEvent(new Event("change", { bubbles: true }));
        noBorderRadio.click();
      }

      if (border_option) {
        border_option.style.display = "none";
      }

      const firstVisibleCanvasVariant = $('.amr-Frame .variant-input.var-input')
        .filter(function () {
          return $(this).css('display') === 'inline-block';
        })
        .first()
        .find('input[type="radio"]');

      if (firstVisibleCanvasVariant.length) {
        firstVisibleCanvasVariant.click();
      }
    }



    function updateSelectedOption(value) {
      console.log('testr');
        if (selectedOptionFrame) {
            selectedOptionFrame.textContent = value;
        }
    }

    // Handle variant clicks to update label
    document.querySelectorAll(".variant-input").forEach(variant => {
        variant.addEventListener("click", function () {
            if (isCanvasActive && this.dataset.value === "Unframed") {
                updateSelectedOption(canvasLabelText);
            } else if (!isCanvasActive) {
                selectVariant(this);
            }
        });
    });

    showFrames(); // Default state

    if (radioCanvas) {
        radioCanvas.addEventListener("click", showCanvas);
    }
    if (radioPrint) {
        radioPrint.addEventListener("click", showFrames);
    }






});


// $(document).ready(function () {
//   $('input[name="properties[Crafted On]"]').on('change click', function () {
//     if ($('#radio-print').is(':checked')) {
//       $('.line-item-parent-effect').show();
//       $('.line-item-parent-effect input[name="properties[Add White Border Effect]"]').prop('disabled', false);
//     } else if ($('#radio-canvas').is(':checked')) {
//       $('.line-item-parent-effect').hide();
//       $('.line-item-parent-effect input[name="properties[Add White Border Effect]"]').prop('disabled', true);
//     }
//   });
// });


// document.addEventListener("DOMContentLoaded", function () {
//   const radioPrint = document.getElementById("radio-print");
//   const radioCanvas = document.getElementById("radio-canvas");
//   const imageElement = document.querySelector('[data-value="Unframed"] .frame-image-box-inner img');
//   const originalImageSrc = imageElement.getAttribute("src");
//   if(radioCanvas)
//   {
// radioCanvas.addEventListener("click", function () {
//     imageElement.setAttribute("src", "https://cdn.shopify.com/s/files/1/0854/9528/3995/files/stretched-canvas.jpg?v=1759904403 ");
//   });
//   }
//   if(radioPrint)
//   {
//  radioPrint.addEventListener("click", function () {
//     imageElement.setAttribute("src", originalImageSrc);
//   });
//   }
 
// });


// frames and canvas logic ends here
//  document.addEventListener("DOMContentLoaded", function () {
//   const frameInputs = document.querySelectorAll('input[name="Frame"]');
//   function updateFrameAttributes(selectedInput) {
//     const selectedFrame = selectedInput?.value || document.querySelector('input[name="Frame"]:checked')?.value;
//     const selectedBorder = document.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
//     if (selectedFrame && selectedBorder) {
//       const imageGrid = document.querySelector(".grid--product-images--partial");
//       if (imageGrid) {
//         imageGrid.setAttribute("data-enable-frame", true);
//         imageGrid.setAttribute("data-border", selectedBorder);
//         imageGrid.setAttribute("data-frame", selectedFrame);
//       }
//     }
//   }
//   frameInputs.forEach((input) => {
//     input.addEventListener("change", function () {
//       updateFrameAttributes(this);
//     });
//   });
//   updateFrameAttributes();
// });



document.addEventListener("DOMContentLoaded", function () {
  const frameInputs = document.querySelectorAll('input[name="Frame"]');
  const borderInputs = document.querySelectorAll('input[name="Border Options"]');
  const imageGrid2 = document.querySelector(".frame-orientation-wrapper");
  function updateFrameAttributesFrame(selectedInput) {
   
    const selectedFrame = selectedInput?.value || document.querySelector('input[name="Frame"]:checked')?.value;
    const selectedBorder = document.querySelector('.amr-Border .variant_select-product.active_seclet .value_option')?.textContent.trim() || '';
    if (selectedFrame && selectedBorder) {
      const imageGrid = document.querySelector(".grid--product-images--partial");
    

      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
        imageGrid.setAttribute("data-frame", selectedFrame);
      }
        if (imageGrid2) {
        imageGrid2.setAttribute("data-enable-frame", true);
        imageGrid2.setAttribute("data-border", selectedBorder);
        imageGrid2.setAttribute("data-frame", selectedFrame);
      }
    }
  }

  // Listen for Frame input changes
  frameInputs.forEach((input) => {
    input.addEventListener("change", function () {
      updateFrameAttributesFrame(this);
    });
  });

document.querySelectorAll('.fk-selector-wrapper input').forEach(input => {
  input.addEventListener('click', function () {
    updateFrameAttributesBorder(this); 
  });
});
 function updateFrameAttributesBorder(selectedInput) {
    const selectedBorder = selectedInput.value;
    if (selectedBorder) {
      const imageGrid = document.querySelector(".grid--product-images--partial");
      if (imageGrid) {
        imageGrid.setAttribute("data-enable-frame", true);
        imageGrid.setAttribute("data-border", selectedBorder);
      }
        if (imageGrid2) {
        imageGrid2.setAttribute("data-enable-frame", true);
        imageGrid2.setAttribute("data-border", selectedBorder);
      }
    }
  }







  // Run once on page load
  updateFrameAttributesFrame();
});



$(document).on("click", "#add-to-cart-btn", function() {
  var $btn = $(this);
  var ID = $btn.data('id');

  $btn.addClass('loading').prop('disabled', true);

  $.ajax({
    type: 'POST',
    url: '/cart/add.js',
    data: {
      quantity: 1,
      id: ID
    },
    dataType: 'json', 
    success: function (data) { 
      document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
      $('.drawer__footer .product-set-wrapper').hide();
      $btn.removeClass('loading').prop('disabled', false);
    },
    error: function() {
      $btn.removeClass('loading').prop('disabled', false);
    }
  });
});


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".view-properties-btn").forEach(btn => {
    btn.addEventListener("click", function () {
      const key = this.getAttribute("data-item-key");
      document.getElementById("properties-" + key).style.display = "block";
    });
  });

  document.querySelectorAll(".close-modal").forEach(closeBtn => {
    closeBtn.addEventListener("click", function () {
      this.closest(".properties-modal").style.display = "none";
    });
  });

  // Close modal on outside click
  window.addEventListener("click", function (e) {
    if (e.target.classList.contains("properties-modal")) {
      e.target.style.display = "none";
    }
  });
});




$(document).ready(function() {
  // Wait for variant inputs to exist
  const checkFirstOption = setInterval(() => {
    const firstOption = $('.variant-input-wrap.size_opt input[type="radio"]').first();
    if (firstOption.length) {
        $('.variant-input-wrap.size_opt label').click();
      firstOption.trigger('click');
      clearInterval(checkFirstOption);
    }
  }, 200);
});





function initFkBorderSync() {
  // Hide native dropdown and label
  const borderDropdown = document.querySelector(".cd-border-options");
  const borderLabel = document.querySelector(".amr-Border .variant__label");

  if (borderDropdown) borderDropdown.style.display = "none";
  if (borderLabel) borderLabel.style.display = "none";

  // Listen to fake radios
  document.querySelectorAll(".fk-bcpo-radios input[type='radio']").forEach(fkRadio => {
    fkRadio.addEventListener("change", function () {
      let value = this.value.trim();

      // ✅ Map fake radio text → dropdown title text
      // “White Border” (radio) → “With White Border” (dropdown)
      let dropdownValue = value === "White Border" ? "With White Border" : value;

      // 1️⃣ Update label text
      const labelValue = this.closest(".fk-selector-wrapper")?.querySelector(".fk-bcpo-value");
      if (labelValue) labelValue.textContent = value;

      // 2️⃣ Sync with real Shopify variant input (.variant-input-wrap)
      const realRadio = document.querySelector(
        `.variant-input-wrap input[type='radio'][value="${CSS.escape(dropdownValue)}"]`
      );
      if (realRadio) {
        realRadio.checked = true;
        realRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }

      // 3️⃣ Sync dropdown visuals
      document.querySelectorAll(".cd-border-options .variant_select-product").forEach(el => {
        el.classList.toggle("active_seclet", el.dataset.title === dropdownValue);
      });
      document.querySelectorAll(".cd-border-options li").forEach(li => {
        li.classList.toggle("text_select", li.dataset.title === dropdownValue);
      });

      // 4️⃣ ✅ Sync with amr-Size radios (auto-click)
      const amrSizeRadio = document.querySelector(
        `.amr-Size input[type='radio'][value="${CSS.escape(dropdownValue)}"]`
      );
      if (amrSizeRadio) {
        amrSizeRadio.checked = true;
        amrSizeRadio.dispatchEvent(new Event("change", { bubbles: true }));
      }
    });
  });

  // ✅ Default: auto-select “No Border”
  const defaultValue = "No Border";
  const defaultRadio = document.querySelector(
    `.fk-bcpo-radios input[type='radio'][value='${defaultValue}']`
  );

  if (defaultRadio && !defaultRadio.checked) {
    defaultRadio.checked = true;
    defaultRadio.dispatchEvent(new Event("change", { bubbles: true }));
  }

  // ✅ Update dropdown visuals immediately
  document.querySelectorAll(".cd-border-options .variant_select-product").forEach(el => {
    el.classList.toggle("active_seclet", el.dataset.title === defaultValue);
  });
  document.querySelectorAll(".cd-border-options li").forEach(li => {
    li.classList.toggle("text_select", li.dataset.title === defaultValue);
  });

  // ✅ Also auto-select in amr-Size section
  const defaultAmrRadio = document.querySelector(
    `.amr-Size input[type='radio'][value="${CSS.escape(defaultValue)}"]`
  );
  if (defaultAmrRadio && !defaultAmrRadio.checked) {
    defaultAmrRadio.checked = true;
    defaultAmrRadio.dispatchEvent(new Event("change", { bubbles: true }));
  }
}


// Run once on load
document.addEventListener("DOMContentLoaded", initFkBorderSync);














